import React, { useState } from 'react';
import Panel from '../../components/ui/Panel';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import Checkbox from '../../components/ui/Checkbox';

const FormsPage: React.FC = () => {
  const [name, setName] = useState('');
  const [amount, setAmount] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const nameOk = name.trim().length >= 1;
  const amountOk = /^[0-9]+$/.test(amount) && Number(amount) > 0;
  const showErrors = submitted && (!nameOk || !amountOk);

  return (
    <div>
      <h1 id="overview" className="text-3xl text-osrs-gold font-bold uppercase mb-4">Forms</h1>
      <p className="text-osrs-yellow mb-8">
        A form is a stone panel of inset fields, a checkbox, and a stone button. Labels stay visible. The button submits the values that are on the panel.
      </p>

      <section id="layout" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Layout</h2>
        <Panel title="Trade offer">
          <form
            className="space-y-4 max-w-md"
            onSubmit={(event) => {
              event.preventDefault();
              setSubmitted(true);
            }}
          >
            <Input
              label="Player name"
              value={name}
              onChange={(event) => setName(event.target.value)}
              status={showErrors && !nameOk ? 'invalid' : nameOk && submitted ? 'valid' : 'default'}
              message={showErrors && !nameOk ? 'Enter a name.' : undefined}
            />
            <Input
              label="Amount"
              value={amount}
              onChange={(event) => setAmount(event.target.value)}
              status={showErrors && !amountOk ? 'invalid' : amountOk && submitted ? 'valid' : 'default'}
              message={showErrors && !amountOk ? 'Enter a number above zero.' : undefined}
            />
            <Checkbox>Remember this player</Checkbox>
            <Button type="submit">Submit</Button>
            {submitted && nameOk && amountOk ? (
              <p className="text-osrs-green">Offer sent for {amount} to {name}.</p>
            ) : null}
          </form>
        </Panel>
      </section>

      <section id="validation" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Validation</h2>
        <Panel>
          <p className="text-osrs-yellow">
            The name must contain a character. The amount must be a whole number above zero. Green means the value can be sent. Red means it cannot.
          </p>
        </Panel>
      </section>

      <section id="error-handling" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Error Handling</h2>
        <Panel>
          <p className="text-osrs-yellow">
            Errors appear under the field after submit. They are not a toast and they are not a placeholder. The field is marked invalid so assistive tech reads the message with the label.
          </p>
        </Panel>
      </section>

      <section id="usage-guidelines" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Usage Guidelines</h2>
        <Panel>
          <ul className="list-disc list-inside text-osrs-yellow space-y-2 ml-4">
            <li>One column of fields inside a panel.</li>
            <li>The submit button is the primary stone button.</li>
            <li>Do not clear a bad value until the player edits it.</li>
          </ul>
        </Panel>
      </section>
    </div>
  );
};

export default FormsPage;
